
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import { mapState } from 'vuex'
export default {
name: 'info',
props: [],
components: {
XHeader,
XInput,
Group,
XButton,
PopupPicker
},
data () {
return {
title: this.$route.meta.title,
nation: [],
politicsStatus: [],
familyInfo: {
name: '',
call: [],
age: '',
job: '',
nationCode: [],
nation: '',
politicsCode: [],
politics: '',
phone: ''
},
isButton: true,
callArr: [['父亲', '母亲', '兄弟姐妹', '其他']],
isAdd: true,
editInfoId: null
}
},
computed: {
...mapState({
userInfo: state => state.userInfo
})
},
created () {
this.getNation()
this.getPoliticsStatus()
},
mounted () {
this.editInfoId = JSON.parse(sessionStorage.getItem('editInfoId'))
if (this.editInfoId) {
this.title = '编辑家庭成员信息'
this.isAdd = false
this.getFamilyInfo(this.editInfoId)
} else {
this.isAdd = true
this.title = '添加家庭成员信息'
}
},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},
save () {
let errorLength = document.getElementsByClassName('weui-cell weui-cell_warn').length
let infoObj = {}
let defaultObj = {
studentId: String(this.userInfo.id)
}
for (var i in this.familyInfo) {
if (typeof this.familyInfo[i] === 'object') {
this.$set(infoObj, i, this.familyInfo[i][0])
} else {
this.$set(infoObj, i, this.familyInfo[i])
}
}
let obj = Object.assign(defaultObj, infoObj)
let isSubmit = false
let valueArr = []
for (var j in obj) {
if (j === 'name' || j === 'call' || j === 'nation' || j === 'politics' || j === 'phone' || j === 'age') {
valueArr.push(obj[j])
}
}
if (valueArr.indexOf('') === -1) {
isSubmit = true
}
let params = obj
if (errorLength === 0 && isSubmit) {
this.$vux.loading.show()
if (this.isAdd) {
this.$api.post('/family', params,
r => {
this.$vux.loading.hide()
this.$vux.toast.show({
text: '提交成功',
position: 'middle',
time: 1000
})
this.$parent.getFamilyInfo()
setTimeout(() => {
this.back()
}, 1000)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
} else {
this.$set(params, 'id', this.editInfoId)
this.$api.put('/family', params,
r => {
this.$vux.loading.hide()
this.$vux.toast.show({
text: '修改成功',
position: 'middle',
time: 1000
})
this.$parent.getFamilyInfo()
setTimeout(() => {
this.back()
}, 1000)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
}
} else {
this.$vux.toast.text('请完整填写信息', 'middle')
}
},
changeInput (name) {






if (name === 'nation') {
this.familyInfo.nation = this.$refs.nation.getNameValues()
} else if (name === 'politics') {
this.familyInfo.politics = this.$refs.politics.getNameValues()
}
},

getNation () {
this.$api.get('/nation', null,
r => {
let data = r.data
let arr = []
data.forEach((element, i) => {
let obj = {
name: element.name,
value: element.code
}
arr.push(obj)
})
this.nation.push(arr)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

getPoliticsStatus () {
this.$api.get('/politicsStatus', null,
r => {
let data = r.data
let arr = []
data.forEach((element, i) => {
let obj = {
name: element.name,
value: element.code
}
arr.push(obj)
})
this.politicsStatus.push(arr)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},
getFamilyInfo (id) {
this.$vux.loading.show()
let params = {
studentId: this.userInfo.id,
id: id
}
this.$api.get('/family', params, r => {
this.$vux.loading.hide()
let data = r.data
if (data.length > 0) {
this.familyInfo = {
name: data[0].name,
call: [],
age: data[0].age,
job: data[0].job,
nationCode: [],
nation: data[0].nation,
politicsCode: [],
politics: data[0].politics,
phone: data[0].phone
}
this.nation[0].forEach(element => {
if (element.name === data[0].nation) {
this.familyInfo['nationCode'].push(element.value)
}
})
this.politicsStatus[0].forEach(element => {
if (element.name === data[0].politics) {
this.familyInfo['politicsCode'].push(element.value)
}
})
this.familyInfo['call'].push(data[0].call)
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/info/parentsInfoEdit.vue